import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Job_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_JOB_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Job Id', columnResourceName: 'colWBJobId', alignment: HorizAlignment.Center}, domainOptions: {}},
    JOB_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Job Id', columnResourceName: 'colJobId', alignment: HorizAlignment.Right}, domainOptions: {}},
    JOB_TYPE:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Job Type', columnResourceName: 'colJobType', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    JOB_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Job Name', columnResourceName: 'colJobName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    JOB_DESCRIPTION:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Job Description', columnResourceName: 'colJobDescription', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 1333}},
    ETL_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'ETLName', columnResourceName: 'colETLName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    DISPLAY_IND:       {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Display Indicator', columnResourceName: 'colDisplayInd', alignment: HorizAlignment.Center}, domainOptions: {}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var JobSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_JOB_ID',
        id_ui: 'JOB_ID',
        name:  'JOB_NAME'},


    searchProviderFields: vUI_Job_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Job_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var JobSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "JobSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'JOB_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'JOB_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'JOB_ID','JOB_NAME','JOB_TYPE','JOB_DESCRIPTION','ETL_NAME','DISPLAY_IND',
        "CREATED_DTTS",
        "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: JobSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var JobSearch: ISearch = {
    searchName: "Find Job",
    renderOptions: { ui5ResourceId: "JobSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [JobSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("JobBO", "Job", JobSearch, "Job Search")

export {JobSearch}